import React from 'react'
import {PortableText} from '@portabletext/react'
import {urlForImage} from './sanityImage'

const components = {
  types: {
    image: ({value}) => {
      const url = urlForImage(value)?.width(1400).fit('max').auto('format').url()
      if (!url) return null
      return (
        <figure className="blog-prose__figure">
          <img src={url} alt={value.alt || ''} className="blog-prose__img" loading="lazy" />
          {value.caption ? (
            <figcaption className="blog-prose__caption">{value.caption}</figcaption>
          ) : null}
        </figure>
      )
    },
  },
  block: {
    h2: ({children}) => <h2 className="blog-prose__h2">{children}</h2>,
    h3: ({children}) => <h3 className="blog-prose__h3">{children}</h3>,
    h4: ({children}) => <h4 className="blog-prose__h4">{children}</h4>,
    blockquote: ({children}) => (
      <blockquote className="blog-prose__blockquote">{children}</blockquote>
    ),
  },
  list: {
    bullet: ({children}) => <ul className="blog-prose__ul">{children}</ul>,
    number: ({children}) => <ol className="blog-prose__ol">{children}</ol>,
  },
  listItem: {
    bullet: ({children}) => <li className="blog-prose__li">{children}</li>,
    number: ({children}) => <li className="blog-prose__li">{children}</li>,
  },
  marks: {
    link: ({children, value}) => {
      const href = value?.href || '#'
      const external = /^https?:\/\//i.test(href)
      return (
        <a
          href={href}
          className="blog-prose__link"
          rel={external ? 'noopener noreferrer' : undefined}
          target={external ? '_blank' : undefined}
        >
          {children}
        </a>
      )
    },
  },
}

export function BlogPortableText({value}) {
  if (!value || !Array.isArray(value)) return null
  return <PortableText value={value} components={components} />
}
